function toStrParams(obj) {
  const str = Object.keys(obj).map(k => {
    const v = obj[k];
    return v ? `${k}=${encodeURIComponent(v)}` : undefined;
  }).filter(it => !!it).join('&');
  return str ? `?${str}` : '';
}
export function constructProductOriginParams(originQuery) {
  var _originQuery$product;
  return toStrParams({
    'origin.cloudId': originQuery.cloudId,
    'origin.product': ((_originQuery$product = originQuery.product) === null || _originQuery$product === void 0 ? void 0 : _originQuery$product.toUpperCase()) || ''
  });
}
export function getContextPathFromProduct(remoteConfigResources) {
  return (remoteConfigResources === null || remoteConfigResources === void 0 ? void 0 : remoteConfigResources.baseUrl) || '';
}
export function getPeopleDirectoryHomePageWithOrgId({
  remoteConfigResources,
  orgId,
  ref,
  src
}) {
  const params = {
    ref,
    src
  };
  return `${getContextPathFromProduct(remoteConfigResources)}${((remoteConfigResources === null || remoteConfigResources === void 0 ? void 0 : remoteConfigResources.peopleDirectoryHome) || '').replace(':orgId', orgId !== null && orgId !== void 0 ? orgId : '')}${toStrParams(params)}`;
}

/**
 * @deprecated use getPeopleDirectoryHomePageWithOrgId
 */
export function getPeopleDirectoryHomePage(remoteConfigResources, ref, src) {
  const params = {
    ref,
    src
  };
  return `${getContextPathFromProduct(remoteConfigResources)}${(remoteConfigResources === null || remoteConfigResources === void 0 ? void 0 : remoteConfigResources.peopleDirectoryHome) || ''}${toStrParams(params)}`;
}
export function getPeopleProfilePage(remoteConfigResources, userId, ref, src) {
  const params = {
    ref,
    src
  };
  return `${getContextPathFromProduct(remoteConfigResources)}${((remoteConfigResources === null || remoteConfigResources === void 0 ? void 0 : remoteConfigResources.peopleProfile) || '').replace(':userId', userId)}${toStrParams(params)}`;
}
export function getTeamProfilePageLinkWithOrgId({
  remoteConfigResources,
  teamId,
  orgId,
  ref,
  src
}) {
  const params = {
    ref,
    src
  };
  return `${getContextPathFromProduct(remoteConfigResources)}${((remoteConfigResources === null || remoteConfigResources === void 0 ? void 0 : remoteConfigResources.teamProfile) || '').replace(':teamId', teamId).replace(':orgId', orgId !== null && orgId !== void 0 ? orgId : '')}${toStrParams(params)}`;
}

/** @deprecated use getTeamProfilePageLinkWithOrgId */
export function getTeamProfilePage(remoteConfigResources, teamId, ref, src) {
  const params = {
    ref,
    src
  };
  return `${getContextPathFromProduct(remoteConfigResources)}${((remoteConfigResources === null || remoteConfigResources === void 0 ? void 0 : remoteConfigResources.teamProfile) || '').replace(':teamId', teamId)}${toStrParams(params)}`;
}
export function trimLastForwardSlash(url = '') {
  if (url[url.length - 1] === '/') {
    return url.slice(0, -1);
  }
  return url;
}